export default {
  isFallback: true,
  excellent: {
    label: 'Excellent (740-900)',
    rates: {
      36: {
        new: 5.99,
        used: 7.09
      },
      48: {
        new: 5.99,
        used: 7.09
      },
      60: {
        new: 5.99,
        used: 7.09
      },
      72: {
        new: 6.59,
        used: 7.09
      }
    },
    creditScoreHigh: 900,
    creditScoreLow: 740
  },
  verygood: {
    label: 'Very Good (700-739)',
    rates: {
      36: {
        new: 5.99,
        used: 8.06
      },
      48: {
        new: 5.99,
        used: 8.06
      },
      60: {
        new: 5.99,
        used: 8.06
      },
      72: {
        new: 6.59,
        used: 8.6
      }
    },
    creditScoreHigh: 739,
    creditScoreLow: 700
  },
  good: {
    label: 'Good (670-699)',
    rates: {
      36: {
        new: 8.99,
        used: 10.27
      },
      48: {
        new: 8.99,
        used: 10.27
      },
      60: {
        new: 8.99,
        used: 10.27
      },
      72: {
        new: 9.59,
        used: 11.42
      }
    },
    creditScoreHigh: 699,
    creditScoreLow: 670
  },
  fair: {
    label: 'Fair (630-669)',
    rates: {
      36: {
        new: 10.99,
        used: 14.24
      },
      48: {
        new: 10.99,
        used: 14.24
      },
      60: {
        new: 10.99,
        used: 14.24
      },
      72: {
        new: 11.59,
        used: 14.24
      }
    },
    creditScoreHigh: 669,
    creditScoreLow: 630
  },
  rebuilding: {
    label: 'Rebuilding (580-629)',
    rates: {
      36: {
        new: 12.99,
        used: 14.24
      },
      48: {
        new: 12.99,
        used: 14.24
      },
      60: {
        new: 12.99,
        used: 14.24
      },
      72: {
        new: 13.59,
        used: 14.24
      }
    },
    creditScoreHigh: 629,
    creditScoreLow: 580
  }
};